<template>
  <div class="entry-content">
    <div class="col-md-12">
      <div class="row">
        <Tab :tabs="filteredTabs" :key="routeKey"/>
      </div>
    </div>
  </div>
</template>

<script>
import Tab from "../../components/Tab";
import { shallowRef } from "vue";

export default {
  components: {
    Tab
  },
  data() {
    return {
      allTabs: [
        {
          name: "Dropdown Lists",
          component: shallowRef(require("./DropdownList/index.vue").default),
          key: "dropdown"
        },
        {
          name: "Project Stage Templates",
          component: shallowRef(
            require("./ProjectTemplates/index.vue").default
          ),
          key: "project"
        },
        {
          name: "Information Memorandum Template",
          component: shallowRef(
            require("./InformationMemorandum/index.vue").default
          ),
          key: "im"
        }
      ],
    };
  },
  computed: {
    filteredTabs() {
      if (this.$route.name === "im-template") {
        // Only show Information Memorandum Template tab
        return this.allTabs.filter(tab => tab.key === "im");
      }
      // Show all tabs for masterdata route
      return this.allTabs;
    },
    routeKey() {
      // Force component re-render when route changes
      return this.$route.name;
    }
  },
  watch: {
    '$route'() {
      // Update page header and breadcrumbs when route changes
      this.updatePageData();
    }
  },
  mounted() {
    this.updatePageData();
  },
  methods: {
    updatePageData() {
      if (this.$route.name === "im-template") {
        this.$ui.setPageHeader({
          title: "Information Memorandum Template",
          showTask: false
        });

        this.$store.commit("app/SET_BREADCRUMBS", [
          {
            name: "Dashboard",
            url: "home"
          },
          {
            name: "Information Memorandum Template",
            url: null,
            active: true
          }
        ]);
      } else {
        this.$ui.setPageHeader({
          title: "Master Data Administration",
          showTask: false
        });

        this.$store.commit("app/SET_BREADCRUMBS", [
          {
            name: "Dashboard",
            url: "home"
          },
          {
            name: "Master Data Administration",
            url: "master_data",
            active: true
          }
        ]);
      }
    }
  }
};
</script>
